import React from 'react'
import {
    Routes,
    Route
  } from 'react-router-dom';
  import Print from '../Print/Print' 
  import Main from '../Main/Main'


const Routing = () => {
  return (
    <>

  <Routes>
    <Route exact path="/" element={<Main />} />
    <Route path="/Resume" element={<Print />} />
  </Routes>
    
    </>
  )
}

export default Routing